export default __webpack_public_path__ + "static/media/close.4116f488.svg";